import { FormGroup, Grid, Paper, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './BookAppointment.module.scss';
import { useBookAppointmentStyles } from '../../muiStyles/BookAppointment.mui';
import CustomButton from '../layout/customButton/CustomButton';
import CustomAlerts from '../alerts/CustomAlerts';
import Modal from '../layout/modal/Modal';

const ClientForm = ({
	handleConfirm,
	formData,
	setFormData,
	profileData,
	setOpenDetailsForm,
	openDetailsForm,
}) => {
	const { email, fullName, phoneNumber } = formData;
	const [snackbar, setSnackbar] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const classes = useBookAppointmentStyles();

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	useEffect(() => {
		setFormData({
			email: profileData?.email || '',
			fullName: profileData?.fullName || '',
			phoneNumber: profileData?.phoneNumber || '',
		});
	}, [profileData]);
	const handleBookAppointment = () => {
		let emailRef = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
		var phoneRef =
			/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

		if (fullName === '' || email === '' || phoneNumber === '') {
			displayAlert('Please fill in all the required fields');
		} else if (!emailRef.test(email)) {
			displayAlert('Invalid email address');
		} else if (!phoneRef.test(phoneNumber)) {
			displayAlert('Invalid phone number');
		} else {
			handleConfirm();
		}
	};
	const displayAlert = (message) => {
		setSnackbar(true);
		setSnackbarMessage(message);

		setTimeout(() => {
			setSnackbar(false);
		}, 3500);
	};

	const closeModalHandler = () => {
		setFormData({
			email: profileData?.email || '',
			fullName: profileData?.fullName || '',
			phoneNumber: profileData?.phoneNumber || '',
		});
		setOpenDetailsForm(false);
	};
	return (
		<>
			<CustomAlerts
				alertType={'error'}
				alertMsg={snackbarMessage}
				snackbar={snackbar}
				setSnackbar={setSnackbar}
			/>
			<Modal
				show={openDetailsForm}
				close={closeModalHandler}
				title='Your Details'
			>
				<div className={styles.clientFormWrapper}>
					<FormGroup>
						<TextField
							className={classes.textField}
							label='Email'
							name='email'
							autoComplete={'off'}
							type='email'
							value={email}
							onChange={(e) => onChange(e)}
							variant='outlined'
							required
						/>
						<TextField
							className={classes.textField}
							label='Full Name'
							name='fullName'
							autoComplete={'off'}
							type='text'
							value={fullName}
							onChange={(e) => onChange(e)}
							variant='outlined'
							required
						/>
						<TextField
							className={classes.textField}
							label='Phone Number'
							name='phoneNumber'
							autoComplete={'off'}
							type='text'
							value={phoneNumber}
							onChange={(e) => onChange(e)}
							variant='outlined'
							required
						/>

						<CustomButton
							onClick={() => handleBookAppointment()}
							width={300}
							height={50}
						>
							Book Appointment
						</CustomButton>
					</FormGroup>
				</div>
			</Modal>
		</>
	);
};

const mapStateToProps = (state) => ({
	profileData: state.profile.profileInfo,
});

export default connect(mapStateToProps)(ClientForm);
